var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('Page',{attrs:{"total":_vm.meta ? _vm.meta.totalCount : 0,"show-total":"","page":_vm.meta ? _vm.meta.currentPage : 0,"page-size":_vm.meta ? _vm.meta.perPage : 0},on:{"on-change":_vm.fetch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }